async function getUsersClientName(accessToken: string): Promise<string> {
  const info = await Promise.resolve('gfk');
  return info;
}

// taken from the existing app graphql resolver - we can't call this service from a browser though as
// it isn't publicly available
// async function sendUserToClientService(accessToken: string) {
//   try {
//     const response = await axios.post(
//       'https://dev-ecosystem-ecosystem-client:8080/graphql',
//       {
//         query: 'mutation persistUser { persistUser { id name } }',
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//         }
//       }
//     );
//     console.log(response);
//     return response.data;

//   } catch {
//     throw new Error("Could not send user to client service");
//   }
// }

export { getUsersClientName };
